import { ApolloQueryResult, DocumentNode } from '@apollo/client';

import { apolloClient } from '../sdk/clients/apolloClient';

export const getHeaderItem = <ResultType, VariablesType>(
  query: DocumentNode,
  variables: VariablesType
): Promise<ApolloQueryResult<ResultType>> => {
  return apolloClient.query({
    query,
    variables,
  });
};
